import React from 'react'
import { ApexCharts } from '../../../../Components'
import { LogAcessoGetAcessosPorPeriodoDoDia } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, larguraColuna, eixoContagem, eixoDias, formatarNumero, tooltipDias, useIndicador } from '../helpers'

export default function AcessosPorPeriodoDoDia({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorPeriodoDoDia, filters, (d) => d.length === 0)
  const dias = data?.map((item) => item.dia) || []

  const options = {
    chart: { type: 'bar', stacked: true },
    colors: [CORES.primaria, CORES.amarelo, CORES.laranja, CORES.azul],
    plotOptions: { bar: { columnWidth: larguraColuna(dias.length) } },
    xaxis: eixoDias(dias),
    yaxis: eixoContagem(data?.map((item) => item.qtdeMadrugada + item.qtdeManha + item.qtdeTarde + item.qtdeNoite) || []),
    legend: { position: 'top', horizontalAlign: 'right' },
    tooltip: { ...tooltipDias(dias), shared: true, intersect: false, y: { formatter: formatarNumero } },
  }

  const series = [
    { name: 'Madrugada (0h–6h)', data: data?.map((item) => item.qtdeMadrugada) || [] },
    { name: 'Manhã (6h–12h)', data: data?.map((item) => item.qtdeManha) || [] },
    { name: 'Tarde (12h–18h)', data: data?.map((item) => item.qtdeTarde) || [] },
    { name: 'Noite (18h–24h)', data: data?.map((item) => item.qtdeNoite) || [] },
  ]

  return (
    <ChartCard title="Acessos por período do dia" subtitle="Horário de Brasília" status={status}>
      <ApexCharts options={options} series={series} type="bar" height={280} />
    </ChartCard>
  )
}
